import { IMicroPageInfo } from './interface';

const defaultInfo: IMicroPageInfo = {
    id: '',
    title: '',
    desc: '',
    template_id: '',
};
const DEFAULT_BASIC_INFO = JSON.stringify({
    blockArr: [],
    blockSource: {},
});
export { defaultInfo, DEFAULT_BASIC_INFO };
